import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { RenderInfoItem } from "ui/molecules/common/RenderInfoItem";
import { ReportModel } from "../../../services/api/types/reports/models/ReportModel";
import { format } from "date-fns";
import clsx from "clsx";
import ViewMore from "ui/molecules/common/ViewMore";
import { Icon } from "ui/gluestack/icon";
import { StarProcessingIcon } from "ui/gluestack/icon/StarProcessingIcon";
import { ReportStatusEnum } from "../../../services/api/types/reports/enums/ReportStatusEnum";
import { formatWithMore } from "ui/utils/listFormattersUtil";
import { snakeToSentence } from "ui/utils/textUtils";

interface Props {
  report: ReportModel;
  newReportIds?: number[];
}

export function ReportSummaryCard({ report, newReportIds }: Props) {
  const createdAt = format(report.created_at, "dd MMMM yyyy");

  return (
    <View
      className={clsx(
        "mt-10 px-6 py-4 border-8 rounded-xl",
        report.status === ReportStatusEnum.PENDING ||
          report.status === ReportStatusEnum.PROCESSING
          ? "border-warning-25"
          : "border-secondary-0",
      )}
    >
      <View className="flex sm:flex-row justify-between">
        <View className="flex-1 gap-y-2">
          <View className="flex flex-row items-center gap-x-2">
            <Text className="text-xl font-semibold">
              {report.resident_name}
            </Text>
            {newReportIds && newReportIds.includes(report.id) && (
              <View className="px-2 py-0.5 bg-success-0 rounded-sm">
                <Text className="text-sm font-medium text-success-500">
                  New
                </Text>
              </View>
            )}
            {report.status === ReportStatusEnum.FAILED && (
              <View className="px-2 py-0.5 bg-error-0 rounded-sm">
                <Text className="text-sm font-medium text-error-500">
                  Failed
                </Text>
              </View>
            )}
          </View>
          <View className="flex flex-row flex-wrap gap-x-2 gap-y-1 text-typography-600">
            <View>{RenderInfoItem(createdAt, false)}</View>
            <View className="flex-shrink">
              {RenderInfoItem(
                formatWithMore(report.categories.map(snakeToSentence)),
                true,
              )}
            </View>
          </View>
        </View>

        <View className="mt-2 sm:mt-0 justify-center">
          {report.status === ReportStatusEnum.PENDING ||
          report.status === ReportStatusEnum.PROCESSING ? (
            <View className="gap-1 px-3 py-2 flex flex-row bg-warning-25">
              <Icon as={StarProcessingIcon} size="sm"></Icon>
              <Text className="text-xs font-normal text-tertiary-950 rounded-sm">
                Generating ...
              </Text>
            </View>
          ) : report.pdf_file?.url ? (
            <ViewMore text="Open" link={report.pdf_file.url} />
          ) : (
            <Text className="text-xs font-normal text-typography-600">
              Report link is not available
            </Text>
          )}
        </View>
      </View>
    </View>
  );
}
